// Module
var code = `<div class="ps-backdrop"></div>
<div class="ps-panel">
  <div class="ps-header">
    <span class="ps-title">Service Monitor</span>
    <button id="sm-close-btn" class="ps-close" title="Close">&times;</button>
  </div>

  <!-- Service list view -->
  <div id="sm-service-list" class="ps-view">
    <div class="ps-toolbar">
      <hs-toolbar-button id="sm-refresh-btn" title="Refresh"></hs-toolbar-button>
    </div>
    <div id="sm-service-table" class="ps-body"></div>
  </div>

  <!-- Pipeline list for a selected service (reuses pipeline-sandbox) -->
  <div id="sm-pipeline-view" class="ps-view hidden"></div>

  <div id="sm-loading-overlay" class="ps-loading-overlay hidden"><span class="ps-spinner"></span></div>
</div>
`;
// Exports
export default code;